export const track = (eventName: string, properties: Record<string, any> = {}): void => {
  (window as any).analytics?.track(eventName, {
    ...properties
  });
};

export const page = (): void => (window as any).analytics?.page();
